import React, {Fragment} from 'react';
import {Breadcrumb, ScrollTopBtn, SecSubTitle, SecTitle, Seo, TitleWrap} from '../components';
import {
    AboutFive,
    AboutFour,
    AboutThree, BrandTwo,
    ContactTwo,
    FeatureTwo,
    FooterOne,
    HeaderOneCopy,
    ProcessTwo, TestimonialTwo
} from '../containers';
import productsData from '../data/products.json';
import EVOData from "../data/EVO.json";
import AboutEight from "../containers/Abouts/AboutEight";
import AboutEightWithSideTabs from "../containers/Abouts/AboutEightWithSideTabs";



const aboutEightData = [
    {
        id: 'tab1',
        title: 'Stock Management',
        subtitle: '',
        icon: 'fas fa-boxes',
        images: [
            'images/evo/stock-Inbound-1.png',
            'images/evo/stock-Inbound-2.png',
            'images/evo/stock-Inbound-3.png',
            'images/evo/stock-Inbound-4.png',
        ],
        texts: [
            "Goods Receipt Note (GRN) : Streamlining Operations with Comprehensive GRN Management",
            "Sales Return : Explore Your Return Process",
            "Putaway : The Heart of Your Warehouse: Putaway Excellence",
            "Expected & Open Purchase Orders : The Heart of Your Warehouse: Putaway Excellence"
        ],
        feature: [],
        btntext: '',
        path: '/service-details'
    },
    {
        id: 'tab2',
        title: 'Order Fulfillment',
        subtitle: '',
        icon: 'fas fa-shipping-fast',
        images: [
            'images/evo/stock-Inbound-1.png',
            'images/evo/stock-Outbound-2.png',
            'images/evo/stock-Outbound-3.png',
            'images/evo/stock-Outbound-4.png',
        ],
        texts: [
            "Sales Delivery : Organize and manage your orders to ensure the successful completion of your deliveries.",
            "Purchase Return : Efficient and Hassle-Free Supplier Return Process.",
            "Picklist : Efficient Order Fulfillment. The Power of Picklists.",
            "Expected & Open Sales Orders : a list of sales orders that a business expects to fulfill in the near future"
        ],
        feature: [],
        btntext: '',
        path: '/service-details'
    },
    {
        id: 'tab3',
        title: 'Inventory Control',
        subtitle: '',
        icon: 'fas fa-balance-scale',
        images: [
            'images/evo/stock-adj-1.png',
            'images/evo/stock-adj-2.png',
        ],
        texts: [
            "Cycle Count (Stock Taking) : Accurate stock taking is essential for efficient inventory management.",
            "Stock Adjustments : Balancing Act: Stock Adjustments for Warehouse Harmony",
        ],
        feature: [],
        btntext: '',
        path: '/service-details'
    },
    {
        id: 'tab4',
        title: 'Team & Operations',
        subtitle: '',
        icon: 'fas fa-users',
        images: [
            'images/evo/team-1.png',
            'images/evo/team-2.png',
            'images/evo/stock-Outbound-3.png',
            'images/evo/team-4.png',
            'images/evo/team-5.png',
        ],
        texts: [
            "Team Management : Efficiently manage teams of all sizes",
            "Items, Serials & Batches Management : Track and manage all inventory items",
            "Picking Management : Streamline and optimize the picking process",
            "Reporting & Analytics : Generate insightful reports and analytics",
            "Printing : Seamlessly print labels and documents",
        ],
        feature: [],
        btntext: '',
        path: '/service-details'
    },
];

const EVO = () => (
    <Fragment>
        <Seo title="EVO-WMS"/>
        <HeaderOneCopy/>
        <Breadcrumb pageName="EVO-WMS"
                    pageSubTitle={"Streamline Your Logistics Processes with EVO"}
                    pageDesc={"Our WMS app integrates mobile and web platforms for optimized inventory control." }
                    bgImage="images/bg/bg-image-2.png"/>


        <div className="container space-extra-bottom">
            <TitleWrap className="text-center space-top ">
                <SecTitle className="text-capitalize h1">EVO-WMS</SecTitle>
                <SecSubTitle> TRANSFORMING BUSINESS OPERATIONS Efficiency Visibility Optimization</SecSubTitle>
            </TitleWrap>

            <div className={'w-100p d-flex align-items-center justify-content-center'}>
                <div className={'images-ss-row'}>
                    <img src={'images/eSyncross/evo.png'} alt="tabthumb"
                         style={{objectFit: 'cover', width: '100%', zIndex: 1}}/>
                </div>
            </div>

            <p className="author-degi space-top text-center"> EVO is a cutting-edge Warehouse Management System (WMS) designed to optimize inventory control, streamline transactions, and enhance overall operational efficiency. With features like electronic visibility and optimized processes</p>

        </div>

        <AboutEightWithSideTabs
            data={aboutEightData}
            title={"EVO-WMS"}
            subtitle={"Key Features"}
            className="space-top space-extra-bottom"/>

        <TestimonialTwo
            title={"what we have covered so far"}
            data={EVOData} className="space-top space-extra-bottom"/>

        <FooterOne/>

        <ScrollTopBtn/>
    </Fragment>
);

export default EVO;